<form class="entry-page-form" [formGroup]="form" (ngSubmit)="onSubmit(form.value)" novalidate autocomplete="off">
    <div class="arrow-wrapper"><div class="arrow" (click)="back()"></div></div>

    <h2 class="title">
        <span *ngIf="model.newProfile">
            This email is already used for an existing account. Please sign in to add a new
            <span class="text-capitalize">{{ model.msg }}</span> profile
        </span>
        <span *ngIf="!model.newProfile">
            This email is already used for an existing account. Please sign in to system.
        </span>
    </h2>

    <cm-external-login-icons *ngIf="!showExternalLogin" [signInType]="signInType" [settings$]="settings$">
    </cm-external-login-icons>

    <div class="form-group">
        <label class="form-label">Email:</label>
        <input type="text" class="form-control" [value]="model.email" disabled />
    </div>

    <div class="form-group" *ngIf="showPasswords">
        <label class="form-label">Password:</label>
        <input
            type="password"
            class="form-control"
            [ngClass]="{ error: form.controls.password.errors?.required && submitted }"
            formControlName="password"
        />
    </div>
    <div class="login-buttons">
        <button [disabled]="submitBtnDisabled" class="btn ch-button" type="submit">log in</button>

        <cm-iframe-external-login
            *ngIf="showExternalLogin"
            [settings]="settings$ | async"
            (callback)="handleCredentialResponse($event)"
        >
        </cm-iframe-external-login>
    </div>

    <div class="error-message" *ngIf="!epResult">{{ errorMessage }}</div>
</form>
<footer class="entry-page-form-footer">
    Forgot password?<a class="cm-link" [routerLink]="['/entry/forgotpw']">Click here</a>
</footer>
